import { memo } from 'react';

import { cn } from 'src/lib/utils';

import type { SVGProps } from 'react';
const SvgIconDepositorH = (props: SVGProps<SVGSVGElement>) => {
  const { className } = props;
  const svgClasses = cn('ck-icon', className);
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 18 14"
      width="1em"
      height="1em"
      role="img"
      className={svgClasses}
    >
      <path d="M8.515 6.792a3.295 3.295 0 0 1-4.107-.103c-.275.35-.694.577-1.166.577H1.305a.577.577 0 0 1-.569-.586V.848c0-.32.251-.586.569-.586h1.937c.43 0 .815.188 1.09.485l.217-.064c.958-.28 1.95-.421 2.945-.421h4.186c1.06 0 2.071.525 2.706 1.402l2.25 3.111c.196.272.3.594.3.933 0 .856-.672 1.558-1.506 1.558-.418 0-.82-.182-1.104-.497l-1.266-1.41a1.51 1.51 0 0 1-1.38.935H9.515c-.278 0-.547.105-.756.296zm-3.472-1.08c.844.77 2.117.77 2.962 0 .417-.38.953-.59 1.51-.59h2.165c.2 0 .369-.17.369-.386a.38.38 0 0 0-.37-.386H8.35a.58.58 0 0 1-.57-.586c0-.32.252-.586.57-.586h3.645c.418 0 .82.181 1.104.497l2.063 2.298c.071.079.166.12.269.12.2 0 .369-.169.369-.385a.4.4 0 0 0-.074-.232l-2.251-3.112a2.23 2.23 0 0 0-1.794-.93H7.494c-.89 0-1.778.127-2.636.377l-.11.032v3.601zm-1.8.382c.199 0 .368-.17.368-.386V1.819a.38.38 0 0 0-.369-.385H1.873v4.66zm8.106 7.218a.44.44 0 0 1-.662 0 .53.53 0 0 1 0-.7l1.136-1.25-1.136-1.25a.53.53 0 0 1 0-.7c.181-.2.48-.2.662 0l1.455 1.599a.53.53 0 0 1 0 .7zm-2.824-.13c-.111.245-.39.354-.627.224a.52.52 0 0 1-.206-.665l1.455-3.2c.112-.244.391-.355.627-.225a.52.52 0 0 1 .206.665zm-1.54.13a.44.44 0 0 1-.662 0l-1.455-1.6a.53.53 0 0 1 0-.7l1.455-1.6c.182-.2.48-.2.662 0a.53.53 0 0 1 0 .7l-1.135 1.25 1.135 1.25a.53.53 0 0 1 0 .7" />
    </svg>
  );
};
const Memo = memo(SvgIconDepositorH);
export default Memo;
